import React, {Component} from 'react'
import {connect} from 'react-redux'
import PropTypes from "prop-types";

import {updateValues} from '../../../routers/data'
import {updateSettings, fetchAvailableCalcs} from '../../../routers/settings'
import Calendar from '../calendar/calendar'

class formReturnDate extends Component{
  static contextTypes = {
    router: PropTypes.object
  }

  onClickMove = (value) => {
    const result = {month: parseInt(value[0], 0), year: parseInt(value[1], 0)}
    this.props.updateSettings({'arrivalMove': result})
  }

  onClickSelect = (value) => {
    this.props.test(value)
    this.props.updateValues({'returndate': value})
  }

  onClickNext = (evt) => {
    window.scrollTo(0, 0)
    this.props.updateSettings({'tab': undefined})
    this.props.fetchAvailableCalcs(this.props.data ,this.props.settings)
  }

  render(){
    const langUrl = this.context.router.route.location.pathname.split('/')[1]
    const { languages } = this.props.settings
    const langPlace = languages[langUrl].fastbooking.return

    const {arrivalMove, availabledates} = this.props.settings
    const {departuredate, returndate} = this.props.data.values
    const {enable} = this.props
    const footerProps = (enable) ? {onClick: () => this.onClickNext(4)}: undefined
    const nextProps = (enable) ? {className: 'next'}: {className: 'next-disabled'}

    const now = new Date(Date.now())
    const nowDate = new Date(now.getFullYear(), now.getMonth(), now.getDate())
    const nowDate3 = new Date(now.getFullYear(), now.getMonth() + 3, now.getDate() - 1)

    const de = new Date(departuredate)
    const re = new Date(returndate)
    const select = [de, re]

    const vi = (departuredate !== undefined)?de: nowDate
    const view = [vi, nowDate3]

    const mArrivalMove = (arrivalMove === undefined)?{month: de.getMonth(), year: de.getFullYear()}: arrivalMove

    let filter = []
    if (availabledates !== undefined){
      if (availabledates.returns !== undefined){
        filter = availabledates.returns
      }else {
        alert('error en Api')
      }

    }

    return (
			<div className='container-return container-fluid'>

        <div className='panel-return row'>
          <div className='date-title'><p>{langPlace.selectdate}</p></div>
          <Calendar move={mArrivalMove} view={view} select={select} filter={filter}
            onClickMove={this.onClickMove} onClickSelect={this.onClickSelect}/>
        </div>


        <div className='footer row' {...footerProps}>
          <span {...nextProps}>{langPlace.find}<i className="fa fa-search" aria-hidden="true"/></span>
        </div>

		  </div>
    )
  }
}

export default connect(
	(state) => ({settings: state.settings, data: state.data}),
  {updateSettings, updateValues, fetchAvailableCalcs}
)(formReturnDate)



// WEBPACK FOOTER //
// ./src/shared/routes/components/fastbooking/panelReturnDate.js